import React, { type PropsWithChildren, memo } from "react";
import * as Styles from "./Content.styles";

const Content: React.FC<PropsWithChildren> = (props) => {
    const { children } = props;
    return (
        <Styles.Wrapper>
            <Styles.Content>{children}</Styles.Content>
        </Styles.Wrapper>
    );
};

export default memo(Content);
